import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, requireAdmin = false }) {
  const { admin, ready } = useAuth();
  const location = useLocation();

  if (!ready) {
    return (
      <div
        data-testid="protected-loading"
        className="min-h-screen flex items-center justify-center bg-background text-muted-foreground"
      >
        <div className="serif italic text-xl text-foreground/70">
          <span className="ornament">Loading</span>
        </div>
      </div>
    );
  }

  if (!admin) {
    return <Navigate to="/admin/login" replace state={{ from: location.pathname }} />;
  }

  if (requireAdmin && admin.role !== "admin") {
    return <Navigate to="/admin/menus" replace />;
  }

  return children;
}
